Vue.component('hire', () => import(/* webpackChunkName: "hire" */ '@/components/hire-wizard/Wraper.vue'));



// WEBPACK FOOTER //
// ./resources/assets/js/components/hire-wizard/index.js